import { ReactComponent } from "./chevron-left-line.svg";

interface Props {
  fill?: string;
  style?: React.CSSProperties;
  width?: string;
  height?: string;
}

const ChevronLeftLineIcon: React.FC<Props> = (Props) => (
  <ReactComponent {...Props} />
);

export default ChevronLeftLineIcon;
